var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixFormsV4SpamSubmission from '@wix/ambassador-forms-v4-spam-submission/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var ReportReason;
(function (ReportReason) {
    ReportReason["UNKNOWN_REASON"] = "UNKNOWN_REASON";
    /** An email quota is reached. There were too many submissions in a short time period with the same email. */
    ReportReason["EMAIL_QUOTA_REACHED"] = "EMAIL_QUOTA_REACHED";
    /** An IP address is is blocklisted. */
    ReportReason["IP_BLOCKLISTED"] = "IP_BLOCKLISTED";
    /** An email is is blocklisted. */
    ReportReason["EMAIL_BLOCKLISTED"] = "EMAIL_BLOCKLISTED";
    /** Reported spam by the AI spam detection model. It uses submission text as an input. */
    ReportReason["AI_REPORTED"] = "AI_REPORTED";
    /** Reported as spam by a submission manager. */
    ReportReason["MANUALLY_REPORTED"] = "MANUALLY_REPORTED";
})(ReportReason || (ReportReason = {}));
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNDEFINED"] = "UNDEFINED";
    SubmissionStatus["PENDING"] = "PENDING";
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var Format;
(function (Format) {
    Format["UNDEFINED"] = "UNDEFINED";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    ProductType["UNKNOWN"] = "UNKNOWN";
    /** Shippable (physical). */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    PriceType["UNKNOWN"] = "UNKNOWN";
    /** Fixed price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Dynamic price from price range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FormatEnumFormat;
(function (FormatEnumFormat) {
    FormatEnumFormat["UNDEFINED"] = "UNDEFINED";
    FormatEnumFormat["DATE"] = "DATE";
    FormatEnumFormat["TIME"] = "TIME";
    FormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    FormatEnumFormat["EMAIL"] = "EMAIL";
    FormatEnumFormat["URL"] = "URL";
    FormatEnumFormat["UUID"] = "UUID";
    FormatEnumFormat["PHONE"] = "PHONE";
    FormatEnumFormat["URI"] = "URI";
    FormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    FormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    FormatEnumFormat["CURRENCY"] = "CURRENCY";
    FormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    FormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FormatEnumFormat || (FormatEnumFormat = {}));
export var StringComponentType;
(function (StringComponentType) {
    StringComponentType["UNKNOWN"] = "UNKNOWN";
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    StringComponentType["DATE_TIME"] = "DATE_TIME";
})(StringComponentType || (StringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var Type;
(function (Type) {
    /** Regular link button */
    Type["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    Type["ACTION"] = "ACTION";
})(Type || (Type = {}));
export var LinkTarget;
(function (LinkTarget) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    LinkTarget["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    LinkTarget["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    LinkTarget["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    LinkTarget["TOP"] = "TOP";
})(LinkTarget || (LinkTarget = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line. */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var DateFormatPart;
(function (DateFormatPart) {
    DateFormatPart["YEAR"] = "YEAR";
    DateFormatPart["MONTH"] = "MONTH";
    DateFormatPart["DAY"] = "DAY";
})(DateFormatPart || (DateFormatPart = {}));
export var DateTimeInputType;
(function (DateTimeInputType) {
    DateTimeInputType["UNKNOWN"] = "UNKNOWN";
    /** Show date and time input */
    DateTimeInputType["DATE_TIME"] = "DATE_TIME";
    /** Show only date input */
    DateTimeInputType["DATE"] = "DATE";
    /** Show only time input */
    DateTimeInputType["TIME"] = "TIME";
})(DateTimeInputType || (DateTimeInputType = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    NumberComponentType["UNKNOWN"] = "UNKNOWN";
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    BooleanComponentType["UNKNOWN"] = "UNKNOWN";
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    ItemType["UNKNOWN"] = "UNKNOWN";
    ItemType["STRING"] = "STRING";
    ItemType["NUMBER"] = "NUMBER";
    ItemType["BOOLEAN"] = "BOOLEAN";
    ItemType["INTEGER"] = "INTEGER";
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypePropertiesType;
(function (PropertiesTypePropertiesType) {
    PropertiesTypePropertiesType["UNKNOWN"] = "UNKNOWN";
    PropertiesTypePropertiesType["STRING"] = "STRING";
    PropertiesTypePropertiesType["NUMBER"] = "NUMBER";
    PropertiesTypePropertiesType["BOOLEAN"] = "BOOLEAN";
    PropertiesTypePropertiesType["INTEGER"] = "INTEGER";
    PropertiesTypePropertiesType["ARRAY"] = "ARRAY";
})(PropertiesTypePropertiesType || (PropertiesTypePropertiesType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["UNKNOWN"] = "UNKNOWN";
    ComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
})(ComponentType || (ComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    WixFileComponentType["UNKNOWN"] = "UNKNOWN";
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    UploadFileFormat["UNDEFINED"] = "UNDEFINED";
    /** Video files */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    PaymentComponentType["UNKNOWN"] = "UNKNOWN";
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
})(PaymentComponentType || (PaymentComponentType = {}));
export var InputType;
(function (InputType) {
    InputType["UNKNOWN"] = "UNKNOWN";
    InputType["STRING"] = "STRING";
    InputType["NUMBER"] = "NUMBER";
    InputType["BOOLEAN"] = "BOOLEAN";
    InputType["ARRAY"] = "ARRAY";
    InputType["OBJECT"] = "OBJECT";
    InputType["WIX_FILE"] = "WIX_FILE";
    InputType["PAYMENT"] = "PAYMENT";
})(InputType || (InputType = {}));
export var Target;
(function (Target) {
    Target["UNDEFINED"] = "UNDEFINED";
    /** Opened in same browser tab */
    Target["SELF"] = "SELF";
    /** Url open in new tab */
    Target["BLANK"] = "BLANK";
})(Target || (Target = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["INPUT"] = "INPUT";
    FieldType["DISPLAY"] = "DISPLAY";
    FieldType["SUBMIT"] = "SUBMIT";
})(FieldType || (FieldType = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    OverrideEntityType["FIELD"] = "FIELD";
    OverrideEntityType["FORM"] = "FORM";
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    Kind["REGULAR"] = "REGULAR";
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    Tag["UNTAGGED"] = "UNTAGGED";
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNDEFINED"] = "UNDEFINED";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
const __Array = {
    checkboxGroupOptions: '_checkboxGroup',
    validation: '_inputFieldArrayType',
};
const __Boolean = { checkboxOptions: '_checkbox' };
const __Number = { numberInputOptions: '_numberInput' };
const __Object = { object: '_inputFieldObjectType' };
const __String = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
};
const _arrayItems = { object: '_objectType' };
const _arrayType = { items: '_arrayItems' };
const _arrayTypeArrayItems = { objectOptions: '_inputFieldObjectType' };
const _checkbox = { label: '_richContent' };
const _checkboxGroup = { description: '_richContent', options: '_option' };
const _createSpamSubmissionRequest = {};
const _createSpamSubmissionResponse = {};
const _dateTimeInput = { description: '_richContent' };
const _deleteSpamSubmissionRequest = {};
const _deleteSpamSubmissionResponse = {};
const _displayField = { header: '_header', richText: '_richText' };
const _dropdown = { description: '_richContent' };
const _fileUpload = { description: '_richContent' };
const _form = {
    fields: '_formField',
    fieldsV2: '_formFieldV2',
    deletedFields: '_formField',
    deletedFieldsV2: '_formFieldV2',
    nestedForms: '_nestedForm',
};
const _formField = { validation: '_validation' };
const _formFieldV2 = {
    inputOptions: '_inputField',
    displayOptions: '_displayField',
    submitOptions: '_submitButton',
};
const _getSpamSubmissionRequest = {};
const _getSpamSubmissionResponse = {};
const _header = { content: '_richContent' };
const _inputField = {
    stringOptions: '__String',
    numberOptions: '__Number',
    booleanOptions: '__Boolean',
    arrayOptions: '__Array',
    objectOptions: '__Object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
};
const _inputFieldArrayType = { items: '_arrayTypeArrayItems' };
const _inputFieldObjectType = { properties: 'Map#_objectTypePropertiesType' };
const _mediaItem = { image: 'wix.common.Image' };
const _nestedForm = { form: '_form' };
const _node = { nodes: '_node' };
const _numberInput = { description: '_richContent' };
const _objectType = { properties: 'Map#_propertiesType' };
const _objectTypePropertiesType = { arrayOptions: '_inputFieldArrayType' };
const _option = { media: '_mediaItem' };
const _payment = { checkboxGroupOptions: '_productCheckboxGroup' };
const _productCheckboxGroup = {
    description: '_richContent',
    options: '_productCheckboxGroupOption',
};
const _productCheckboxGroupOption = { media: '_mediaItem' };
const _propertiesType = { array: '_arrayType' };
const _querySpamSubmissionsRequest = {};
const _querySpamSubmissionsResponse = {};
const _radioGroup = { description: '_richContent' };
const _reportNotSpamSubmissionRequest = {};
const _reportNotSpamSubmissionResponse = {};
const _reportSpamSubmissionRequest = {};
const _reportSpamSubmissionResponse = {};
const _richContent = { nodes: '_node' };
const _richText = { content: '_richContent' };
const _submitButton = { thankYouMessage: '_thankYouMessage' };
const _textInput = { description: '_richContent' };
const _thankYouMessage = { text: '_richContent' };
const _updateSpamSubmissionRequest = {};
const _updateSpamSubmissionResponse = {};
const _validateSpamRequest = { form: '_form' };
const _validateSpamResponse = {};
const _validation = { array: '_arrayType', object: '_objectType' };
const _wixFile = { fileUploadOptions: '_fileUpload' };
/**
 * Checks if submission is a spam. For spam, persists a spam submission.
 * @param submission - Submission.
 * @internal
 * @documentationMaturity preview
 * @requiredField options
 * @requiredField options.form
 * @requiredField options.form._id
 * @requiredField options.form.fields
 * @requiredField submission
 * @requiredField submission.formId
 */
export function validateSpam(submission, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submission: '$[0]', form: '$[1].form' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _validateSpamRequest,
            depSchemas: {
                __Array,
                __Boolean,
                __Number,
                __Object,
                __String,
                _arrayItems,
                _arrayType,
                _arrayTypeArrayItems,
                _checkbox,
                _checkboxGroup,
                _dateTimeInput,
                _displayField,
                _dropdown,
                _fileUpload,
                _form,
                _formField,
                _formFieldV2,
                _header,
                _inputField,
                _inputFieldArrayType,
                _inputFieldObjectType,
                _mediaItem,
                _nestedForm,
                _node,
                _numberInput,
                _objectType,
                _objectTypePropertiesType,
                _option,
                _payment,
                _productCheckboxGroup,
                _productCheckboxGroupOption,
                _propertiesType,
                _radioGroup,
                _richContent,
                _richText,
                _submitButton,
                _textInput,
                _thankYouMessage,
                _validation,
                _wixFile,
            },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _validateSpamResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submission, options]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.validateSpam(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submission',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new spam submission.
 * To upload submission media, use the FormSubmissionService.getMediaUploadUrl endpoint
 * @param spamSubmission - Spam submission to be created.
 * @internal
 * @documentationMaturity preview
 * @requiredField spamSubmission
 * @requiredField spamSubmission.formId
 * @requiredField spamSubmission.reportReason
 * @requiredField spamSubmission.submissions
 * @requiredField spamSubmission.submitter
 * @adminMethod
 * @returns The created spam submission.
 */
export function createSpamSubmission(spamSubmission) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { spamSubmission: '$[0]' };
        const responseTransformation = '$.spamSubmission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([spamSubmission]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.createSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'spamSubmission',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get a spam submission by id.
 * @param spamSubmissionId - Id of the spam submission to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField spamSubmissionId
 * @adminMethod
 * @returns The retrieved spam submission.
 */
export function getSpamSubmission(spamSubmissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { spamSubmissionId: '$[0]' };
        const responseTransformation = '$.spamSubmission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([spamSubmissionId]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.getSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'spamSubmissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Delete a spam submission.
 * @param spamSubmissionId - Id of the spam submission to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField spamSubmissionId
 * @adminMethod
 */
export function deleteSpamSubmission(spamSubmissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { spamSubmissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([spamSubmissionId]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.deleteSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'spamSubmissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report a spam submission as not spam. The submission is created, and the spam one is deleted.
 * Submission automations are triggered the same way as in standard submission creation flow.
 * @param spamSubmissionId - Id of the spam submission to report as not spam.
 * @internal
 * @documentationMaturity preview
 * @requiredField spamSubmissionId
 * @adminMethod
 */
export function reportNotSpamSubmission(spamSubmissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { spamSubmissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reportNotSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reportNotSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([spamSubmissionId]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.reportNotSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'spamSubmissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report a submission as spam. The spam submission is created, and the submission is deleted.
 * @param submissionId - Id of the submission to report as spam.
 * @internal
 * @documentationMaturity preview
 * @requiredField submissionId
 * @adminMethod
 */
export function reportSpamSubmission(submissionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reportSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reportSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.reportSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query spam submissions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function querySpamSubmissions() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.spamSubmissions',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _querySpamSubmissionsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _querySpamSubmissionsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#spamSubmissions']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixFormsV4SpamSubmission.querySpamSubmissions(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Updates a spam submission, supports partial update.
 * You need to pass the latest 'revision' for a successful update.
 * @param _id - Spam submission id.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField spamSubmission
 * @requiredField spamSubmission.formId
 * @requiredField spamSubmission.revision
 * @adminMethod
 * @returns Updated spam submission.
 */
export function updateSpamSubmission(_id, spamSubmission, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            spamSubmission: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.spamSubmission';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['spamSubmission']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, spamSubmission, options]);
        const reqOpts = ambassadorWixFormsV4SpamSubmission.updateSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'spamSubmission',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=forms-v4-spam-submission.universal.js.map